import { useState } from 'react';
import type { Participant, Room } from 'livekit-client';

/**
 * A roda de fotos de quem esta na sala, no estilo do Discord: circulos
 * sobrepostos com uma borda da cor do fundo, que e o que cria a separacao
 * entre eles sem precisar de espaco.
 *
 * Mostra quem esta **vendo a sala** — nao quem esta no canal de voz. E a
 * informacao que importa para quem transmite: quem esta de fato olhando.
 */

const LIMITE = 5;

interface Pessoa {
  id: string;
  nome: string;
  avatar: string | null;
}

/** O avatar viaja no metadata do token, posto la pelo servidor. */
function lerAvatar(p: Participant): string | null {
  if (!p.metadata) return null;
  try {
    return (JSON.parse(p.metadata) as { avatar?: string }).avatar ?? null;
  } catch {
    return null;
  }
}

function iniciais(nome: string): string {
  const partes = nome.trim().split(/\s+/).slice(0, 2);
  return partes.map((p) => p[0] ?? '').join('').toUpperCase() || '?';
}

export function Faces({ room }: { room: Room }) {
  const [quebradas, setQuebradas] = useState<Set<string>>(new Set());

  const pessoas: Pessoa[] = [
    {
      id: room.localParticipant.identity,
      nome: room.localParticipant.name ?? 'Voce',
      avatar: lerAvatar(room.localParticipant),
    },
    ...[...room.remoteParticipants.values()].map((p) => ({
      id: p.identity,
      nome: p.name ?? p.identity,
      avatar: lerAvatar(p),
    })),
  ];

  const visiveis = pessoas.slice(0, LIMITE);
  const resto = pessoas.length - visiveis.length;

  return (
    <div className="faces" title={pessoas.map((p) => p.nome).join(', ')}>
      {visiveis.map((p, i) => {
        const usarImagem = p.avatar && !quebradas.has(p.id);
        return (
          <div
            key={p.id}
            className="face"
            title={p.nome}
            // Primeiro por cima: cada circulo cobre o seguinte, nunca o anterior.
            // Assim quem cai nas iniciais nunca tem a letra comida pelo vizinho.
            style={{ zIndex: visiveis.length - i }}
          >
            {usarImagem ? (
              <img
                src={p.avatar!}
                alt={p.nome}
                loading="lazy"
                // Se o CDN falhar, cai nas iniciais em vez de um circulo vazio.
                onError={() => setQuebradas((s) => new Set(s).add(p.id))}
              />
            ) : (
              <span className="face-initials">{iniciais(p.nome)}</span>
            )}
          </div>
        );
      })}
      {resto > 0 && <div className="face face-more">+{resto}</div>}
    </div>
  );
}
